export default __webpack_public_path__ + "static/media/leaf2.66b782d5.svg";